module.exports = __webpack_public_path__ + "img/goal.a058c760.png";